module.exports = "<div class=\"inmodal\">\n  <div class=\"color-line\"></div>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">{{title}}</h4>\n    <small class=\"font-bold\">{{subject}}</small>\n  </div>\n  <div class=\"modal-body\">\n    <p>{{message}}</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"no()\">No</button>\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"yes()\">Yes</button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/modals/ConfirmModal/confirmModal.html
// module id = 357
// module chunks = 0